function MicrophoneIcon(props)
{
    return(
        <svg className={props.class} viewBox="0 0 32 32"><g id="microphone"><path d="M16,20a5,5,0,0,0,5-5V7A5,5,0,0,0,11,7v8A5,5,0,0,0,16,20ZM13,7a3,3,0,0,1,6,0v8a3,3,0,0,1-6,0Z"/><path d="M25,15a1,1,0,0,0-2,0A7,7,0,0,1,9,15a1,1,0,0,0-2,0,9,9,0,0,0,8,8.94s0,0,0,.06v5a1,1,0,0,0,2,0V24s0,0,0-.06A9,9,0,0,0,25,15Z"/></g></svg>
    )
}

export default MicrophoneIcon